<template>
  <div class="no-data">
    <img :src="img" alt />
    <span class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'm-no-data',
  props: {
    text: {
      type: String,
      default: '没有找到视频'
    },
    type: {
      type: String,
      default: 'video'
    }
  },
  computed: {
    img() {
      let res = 'iconNoVideo.png';
      if (this.type === 'live') {
        res = 'iconNoLive.png';
      } else if (this.type === 'course') {
        res = 'iconNoCourse.png';
      }
      return require('@/assets/' + res);
    }
  }
};
</script>

<style lang="less" scoped>
.no-data {
  position: relative;
  width: 100%;
  // margin-top: 120px;

  img {
    width: 100%;
    padding-top: 120px;
  }

  .text {
    position: absolute;
    left: 0;
    bottom: 40px;
    width: 100%;
    font-size: 14px;
    color: #777;
    text-align: center;
  }
}
</style>
